// extracted by mini-css-extract-plugin
export default {"CarMarks":"CarMarks_CarMarks__+E4q4","CarMarks__new":"CarMarks_CarMarks__new__ESYo2","CarMarks__table":"CarMarks_CarMarks__table__JZ3xr"};